module.exports = __webpack_public_path__ + "img/goat.7566929e.svg";